import * as Yup from "yup"

import {
	AssetFilter,
	AssetType,
	ContractType,
	PositionType,
	SwitchEnum,
	SwitchUtils,
} from "models"

export class AssetAdvancedSearchForm
{
	address: string|null = null
	city: string|null = null
	province: string|null = null
	region: string|null = null
	position: PositionType|null|"" = null
	assetType: AssetType|null|"" = null
	divisible: SwitchEnum = SwitchEnum.UNINTERESTING
	airConditioning: SwitchEnum = SwitchEnum.UNINTERESTING
	parkingSlots: SwitchEnum = SwitchEnum.UNINTERESTING
	shopWindows: number|null = null
	contractType: ContractType|null|"" = null
	glaMin: string|null = null
	glaMax: string|null = null
	minPrice: string|null = null
	maxPrice: string|null = null

	public toRequest(): AssetFilter
	{
		const result = new AssetFilter()

		result.address = this.address === "" ? null : this.address
		result.city = this.city === "" ? null : this.city
		result.province = this.province === "" ? null : this.province
		result.region = this.region === "" ? null : this.region

		let position = this.position
		if(position === "") {
			result.positionType = null
		} else {
			result.positionType = position
		}

		const assetTypeRaw = this.assetType
		const assetType: AssetType | null = typeof assetTypeRaw === "string" && assetTypeRaw.length > 0
			? assetTypeRaw as AssetType
			: null
		if(!assetType) {
			result.type = null
		} else {
			result.type = assetType
		}

		result.divisible = SwitchUtils.setSwitchValue(this.divisible !== undefined ? this.divisible : SwitchEnum.UNINTERESTING)

		result.parkingSlots = SwitchUtils.setSwitchValue(this.parkingSlots !== undefined ? this.parkingSlots : SwitchEnum.UNINTERESTING)

		result.airConditioning = SwitchUtils.setSwitchValue(this.airConditioning !== undefined ? this.airConditioning : SwitchEnum.UNINTERESTING)

		let contractType = this.contractType
		if(contractType === "") {
			result.contractType = null
		} else {
			result.contractType = contractType
		}

		if(this.glaMin && this.glaMin !== ""){
			result.glaMin = parseInt(this.glaMin)
		}
		else {
			result.glaMin = null
		}
		if(this.glaMax && this.glaMax !== ""){
			result.glaMax = parseInt(this.glaMax)
		}
		else {
			result.glaMax = null
		}
		if(this.minPrice && this.minPrice !== ""){
			result.priceMin = parseInt(this.minPrice)
		}
		else {
			result.priceMin = null
		}
		if(this.maxPrice && this.maxPrice !== ""){
			result.priceMax = parseInt(this.maxPrice)
		}
		else {
			result.priceMax = null
		}

		result.shopWindows = this.shopWindows !== undefined ? this.shopWindows : null

		result.orderType = null
		result.orderBy = null

		return result
	}
}

const AssetAdvancedSearchValidation = {
	shopWindows: Yup.number()
		.moreThan(-1)
		.nullable()
		.transform((v, o) => o === '' ? null : v)
		.notRequired(),
	minPrice: Yup.number()
		.moreThan(-1)
		.nullable()
		.transform((v, o) => o === '' ? null : v)
		.notRequired(),
	maxPrice: Yup.number()
		.moreThan(-1)
		.nullable()
		.transform((v, o) => o === '' ? null : v)
		.notRequired(),
}

export default Yup.object()
	.shape(
		AssetAdvancedSearchValidation,
	)
	.required()
